/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { registerLanguage } from '../_.contribution.js';
registerLanguage({
    id: 'postiats',
    extensions: ['.dats', '.sats', '.hats'],
    aliases: ['ATS', 'ATS/Postiats'],
    loader: function () { return import('./postiats.js'); }
});
